import React, { useEffect, useRef, useState } from 'react';
import qs from 'qs';
import bemCn from 'bem-cn';
import isbot from 'isbot';
import {
    LOW_CLEAN_THRESHOLD,
    LOW_FENCING_THRESHOLD,
    LOW_PHOTOS_THRESHOLD,
    LOW_RATING_THRESHOLD,
    RESERVATION_TYPE,
} from '../../consts/reservation.consts';
import { showPrice } from '../../helpers/price';
import { AUTH_TESTS } from './auth-test.const';
import { EVENTS_NAME } from '../../consts/event.consts';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import DesktopBookBlock from './desktop-book-block';
import { RouteFormatter } from '../../routes';
import { sortByObjTitle } from '../../helpers/reservation';
import { scrollToElement } from '../../helpers/common';
import { convertCityState } from '../../helpers/spot-slug';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import { getTestWithProbSSR } from '../../helpers/ssr';
import { SIGN_UP_SRC, USER_TEST_GROUP } from '../../consts/profile.const';
import { ENCLOSURE_TYPE, SPOT_MIN_REQ_PHOTOS, SPOT_REVIEWS_SORT_CONTENT, SPOT_SRC, SPOT_SRC_MEMBERSHIP } from '../../consts/spot.consts';
import ListingAvailability from '../../components/listing-availability';
import GuestSpotCalendar from '../../components/calendar/guest-calendar-ssr';
import SeoLocalBusiness from '../../components/seo-local-business';
import ReservationPanel from '../../components/reservation-panel';
import ListingAmenities from '../../components/listing-amenities';
import ListingLocation from '../../components/listing-location/index-ssr';
import BlurSignupModal from '../../components/modal-blur-signup';
import ListingPresent from '../../components/listing-present';
import ListingReviews from '../../components/listing-reviews';
import ListingFencing from '../../components/listing-fencing';
import ListingExtras from '../../components/listing-extras';
import MobileSubPage from '../../components/mobile-sub-page';
import ListingRules from '../../components/listing-rules';
import ListingHost from '../../components/listing-host';
import ModalMobile from '../../components/modal-mobile';
import SniffButton from '../../components/sniff-button';
import SvgSubscription from 'src/assets/svg/SvgSubscription.svg';
import SvgCross2 from 'src/assets/svg/SvgCross2.svg';
import './index.scss';

import RenderMobilePhotoGallery from './render-mobile-photo-gallery';
import RenderUserIsMember from './render-user-is-member';
import RenderModalWarning from './render-modal-warning';
import RenderNearbySpots from './render-nearby-spots-ssr';
import RenderHeadDesktop from './render-head-desktop';
import RenderHeadMobile from './render-head-mobile';
import RenderSpotBadge from './render-spot-badge';
import RenderPrice from './render-price';
import PublicPark from './public-park';

const bs = bemCn('sniffpass-modal-spot-details');

const CookieService = require('../../services/cookie.service');
const useMutateTrackEvent = require('../../services/hooks/useMutateTrackEvent');
const useGetProbabilityTest = require('../../services/hooks/useGetProbabilityTest');
const useGetSpotPhotosPaginated = require('../../services/hooks/useGetSpotPhotosPaginated');
const useMutateViewEnhancedReview = require('../../services/hooks/useMutateViewEnhancedReview');
const useMutateViewSpotLastActive = require('../../services/hooks/useMutateViewSpotLastActive');
const useMutateViewSpotDetailFaqs = require('../../services/hooks/useMutateViewSpotDetailFaqs');
const useMutateViewSmallDogFencing = require('../../services/hooks/useMutateViewSmallDogFencing');
const useMutateViewRecentReviews = require('../../services/hooks/useMutateViewRecentReviews');

const favSpots = [];

const SpotViewPage = ({
    spot,
    useRef: useRefSSR,
    useState: useStateSSR,
    useEffect: useEffectSSR,
    userDetails = {},
    useCallback,
    usePrevious,
    useGetAvailableTimes,
    useLazyGetIntentCal,
    useUpdateIntent,
    useMutateFavorites,
    useGetShareLink,
    useAddReply,
    useDeleteReply,
    useHandleUpvote,
    useGetSpotReviews,
    useOnScreen,
    useGetReviews,
    Select,
    serverSSR,
}) => {
    const isMobile = useMobileScreen();
    const hostRef = useRef(null);
    const reviewsRef = useRef(null);
    const { getReviews, dataReviews } = serverSSR ? {} : useGetReviews();
    const { trackEvent } = serverSSR ? {} : useMutateTrackEvent.default();
    const { getProbTest } = serverSSR ? {} : useGetProbabilityTest.default();
    const { getSpotPhotosPaged, data } = serverSSR ? {} : useGetSpotPhotosPaginated.default(true);
    const { mutateViewEnhancedReview } = serverSSR ? {} : useMutateViewEnhancedReview.default();
    const { viewSpotLastActive } = serverSSR ? {} : useMutateViewSpotLastActive.default();
    const { viewSpotDetailFaqs } = serverSSR ? {} : useMutateViewSpotDetailFaqs.default();
    const { viewSmallDogFencing } = serverSSR ? {} : useMutateViewSmallDogFencing.default();
    const { mutateViewRecentReviews } = serverSSR ? {} : useMutateViewRecentReviews.default();
    const [rating, setRating] = useState(null);
    const [sortBy, setSortBy] = useState('COMMENT');
    const [shareModal, setShareModal] = useState(false);
    const [sortReviews, setSortReviews] = useState(SPOT_REVIEWS_SORT_CONTENT.COMMENT);
    const [showCalendar, setShowCalendar] = useState((typeof window !== 'undefined' && userDetails?.id && window.location.hash?.substring(1)) || '');
    const [openSniffpass, setOpenSniffpass] = useState(false);
    const [isBlurTest, setIsBlurTest] = useState(null);
    const [isEnhancedReviewTest, setIsEnhancedReviewTest] = useState(null);
    const [isSpotLastActTest, setIsSpotLastActTest] = useState(null);
    const [isSpotFaqsTest, setIsSpotFaqsTest] = useState(null);
    const [isSmallDogFenceTest, setIsSmallDogFenceTest] = useState(null);
    const [isRecentReviewsTest, setIsRecentReviewsTest] = useState(null);
    const [singleViewPhoto, setSingleViewPhoto] = useState(null);
    const [mobilePhotoCount, setMobilePhotoCount] = useState(0);
    const [desktopPhotoCount, setDesktopPhotoCount] = useState(0);
    const [mobilePhotoGallery, setMobilePhotoGallery] = useState(false);
    const [desktopPhotoGallery, setDesktopPhotoGallery] = useState(false);
    const [isFaqOpen, setIsFaqOpen] = useState(false);
    const [warning, setWarning] = useState({
        isOpen: false,
        isLowRating: false,
        isLongInactive: false,
        type: null,
    });

    const spotPhotos = data?.spot?.spotPhotos || spot?.allPhotos.map((p) => ({ imageAws: p }));
    const nearbySpotSPhotos = data?.spot?.nearbySpots;
    const isCanReqPhotos = spot.photosCount < SPOT_MIN_REQ_PHOTOS;
    const publicPark = Boolean(spot?.parkName);
    const spotPublishedAt = spot?.publishedAt;
    const lastActiveAt = spot?.lastActiveAt;

    const listBread = [
        {
            name: 'All dog parks',
            url: RouteFormatter.listings({}),
        },
        {
            name: spot?.state || '',
            url: RouteFormatter.listings({ first: spot?.stateUrl }) || '',
        },
        {
            name: spot?.city || '',
            url: spot?.cityUrl || convertCityState(spot?.city || '', spot?.state || '') || '',
        },
        {
            name: spot?.title || spot?.parkName || '',
        },
    ];

    useEffect(() => {
        const htmlEle = document.documentElement;

        if (mobilePhotoGallery) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            htmlEle.classList.add('root-html-focused');
        } else {
            setMobilePhotoCount(0);
            htmlEle.classList.remove('root-html-focused');
        }

        return () => htmlEle.classList.remove('root-html-focused');
    }, [mobilePhotoGallery]);

    useEffect(() => {
        if (!publicPark) {
            window.fbq('track', 'ViewContent', { content_ids: [`${spot.id}`], content_type: 'product' }, { eventID: `view_content.${spot.id}` });

            const itemsData = [
                {
                    item_id: `spot_${spot.id}`,
                    price: spot.price,
                },
            ];
            window.axon && window.axon('track', 'view_item', { items: itemsData, currency: 'USD' });
        }
    }, [publicPark]);

    useEffect(() => {
        const isBotCrawl = isbot(navigator.userAgent);
        const sessionUuid = CookieService.default.get(COOKIE_PARAM_NAME.SESSION_UUID);

        trackEvent({ name: EVENTS_NAME.spot_detail_view, properties: { spot_id: spot.id } });

        const q = qs.parse(window.location.search, { ignoreQueryPrefix: true });

        Object.keys(q).forEach((key) => {
            if (key.startsWith('utm_')) {
                CookieService.default.set(key, q[key], { expires: 1 });
            }
        });

        const initTest = async () => {
            const testPromises = [
                getTestWithProbSSR({
                    getProbTest,
                    cookie: COOKIE_PARAM_NAME.FRONT_ENHANCED_REVIEW,
                    userTestGroup: USER_TEST_GROUP.FRONT_ENHANCED_REVIEW,
                }).then((res) => {
                    if (res !== null) {
                        mutateViewEnhancedReview({ variables: { testGroup: res, sessionUuid } });
                        setIsEnhancedReviewTest(res);
                    }
                }),
                // spot last active test
                getTestWithProbSSR({
                    getProbTest,
                    cookie: COOKIE_PARAM_NAME.FRONT_SPOT_LAST_ACTIVE,
                    userTestGroup: USER_TEST_GROUP.FRONT_SPOT_LAST_ACTIVE,
                }).then((res) => {
                    if (res !== null) {
                        viewSpotLastActive({ variables: { testGroup: res, sessionUuid } });
                        setIsSpotLastActTest(res);
                    }
                }),
                // spot faqs test
                getTestWithProbSSR({
                    getProbTest,
                    cookie: COOKIE_PARAM_NAME.FRONT_SPOT_DETAIL_FAQS,
                    userTestGroup: USER_TEST_GROUP.FRONT_SPOT_DETAIL_FAQS,
                }).then((res) => {
                    if (res !== null) {
                        viewSpotDetailFaqs({ variables: { testGroup: res, sessionUuid } });
                        setIsSpotFaqsTest(res);
                    }
                }),
                // small dog fencing test
                getTestWithProbSSR({
                    getProbTest,
                    cookie: COOKIE_PARAM_NAME.FRONT_SMALL_DOG_FENCING,
                    userTestGroup: USER_TEST_GROUP.FRONT_SMALL_DOG_FENCING,
                }).then((res) => {
                    if (res !== null) {
                        viewSmallDogFencing({ variables: { testGroup: res } });
                        setIsSmallDogFenceTest(res);
                    }
                }),
                // recent reviews test
                getTestWithProbSSR({
                    getProbTest,
                    cookie: COOKIE_PARAM_NAME.FRONT_RECENT_REVIEWS,
                    userTestGroup: USER_TEST_GROUP.FRONT_RECENT_REVIEWS,
                }).then((res) => {
                    if (res !== null) {
                        mutateViewRecentReviews({ variables: { testGroup: res } });
                        setIsRecentReviewsTest(res);
                    }
                }),
            ];

            await Promise.allSettled(testPromises);
        };

        !isBotCrawl && initTest();

        getSpotPhotosPaged({ variables: { id: spot.id, page: 1, limit: 50 } });

        return () => {
            setSingleViewPhoto(null);
            setMobilePhotoCount(0);
            setDesktopPhotoCount(0);
            setMobilePhotoGallery(false);
            setDesktopPhotoGallery(false);
        };
    }, []);

    // guest auth test
    useEffect(() => {
        const init = async () => {
            if (mobilePhotoGallery || desktopPhotoGallery) {
                const re = `${window.location.pathname}#${mobilePhotoGallery ? AUTH_TESTS.MOBILE_PHOTO_GALLERY : AUTH_TESTS.DESKTOP_PHOTO_GALLERY}`;
                CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, publicPark ? SIGN_UP_SRC.CITY_DOG_PARK_WEB : SIGN_UP_SRC.SPOT_DETAILS_WEB, {
                    expires: 1,
                });
                CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
                setSingleViewPhoto(null);
            }
        };

        init();
    }, [mobilePhotoGallery, desktopPhotoGallery]);

    useEffect(() => {
        if (!isBlurTest && showCalendar) {
            setShowCalendar('');
        }
        if (!isBlurTest && isFaqOpen) {
            setIsFaqOpen(false);
        }
    }, [isBlurTest]);

    const handleChangeStars = () => {
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, RouteFormatter.parkReview({ id: spot.id }, { query: { rating } }), { expires: 1 });
        CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.CITY_DOG_PARK_WEB, { expires: 1 });
        setTimeout(() => {
            window.location = RouteFormatter.signUp();
        }, 200);
    };

    const changeSort = (key, force) => {
        setSortBy(key);
        getReviews({
            variables: {
                id: spot.id,
                sortBy: SPOT_REVIEWS_SORT_CONTENT[key].sortBy,
                sortOrder: SPOT_REVIEWS_SORT_CONTENT[key].sortOrder,
                first: 10,
            },
            fetchPolicy: force ? 'network-only' : 'cache-and-network',
        });
        setSortReviews(SPOT_REVIEWS_SORT_CONTENT[key]);
    };

    const onAskQuestion = async () => {
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, RouteFormatter.chatConversation({ channelId: spot.id }), { expires: 1 });
        CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.MESSAGE_HOST_WEB, { expires: 1 });
        setIsBlurTest(true);
    };

    const singlePhotoHandler = (id) => {
        setMobilePhotoCount(id + 1);
        setSingleViewPhoto(id);
    };

    const toggleFaq = () => {
        setIsFaqOpen(!isFaqOpen);

        if (!isFaqOpen) {
            const re = `${window.location.pathname}#${AUTH_TESTS.FAQS}`;
            CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.SPOT_DETAILS_WEB, { expires: 1 });
            CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
            setIsBlurTest(true);
        }
    };

    const toggleDesktopPhotoGallery = () => {
        const re = `${window.location.pathname}#${AUTH_TESTS.DESKTOP_PHOTO_GALLERY}`;
        CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, publicPark ? SIGN_UP_SRC.CITY_DOG_PARK_WEB : SIGN_UP_SRC.SPOT_DETAILS_WEB, {
            expires: 1,
        });
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
        setIsBlurTest(true);
    };

    const handleNextDesktopGallery = () => {
        let newIdxPhoto = desktopPhotoCount;

        if ((isCanReqPhotos && newIdxPhoto == spot.spotPhotos?.length) || (!isCanReqPhotos && newIdxPhoto + 1 == spot.spotPhotos?.length)) {
            newIdxPhoto = 0;
        } else {
            newIdxPhoto++;
        }

        setDesktopPhotoCount(newIdxPhoto);
    };

    const handleBackDesktopGallery = () => {
        let newIdxPhoto = desktopPhotoCount;

        if (newIdxPhoto - 1 < 0) {
            newIdxPhoto = isCanReqPhotos ? spot.spotPhotos?.length : spot.spotPhotos.length - 1;
        } else {
            newIdxPhoto--;
        }

        setDesktopPhotoCount(newIdxPhoto);
    };

    const handleSwipeMobile = async () => {
        const re = `${window.location.pathname}#${AUTH_TESTS.MOBILE_PHOTO_GALLERY}`;
        CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, publicPark ? SIGN_UP_SRC.CITY_DOG_PARK_WEB : SIGN_UP_SRC.SPOT_DETAILS_WEB, {
            expires: 1,
        });
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
        setSingleViewPhoto(null);
        setMobilePhotoCount(0);
        setDesktopPhotoCount(0);
        setMobilePhotoGallery(false);
        setDesktopPhotoGallery(false);
        setIsBlurTest(true);
    };

    const toggleShareModal = () => setShareModal((s) => !s);
    const toggleOpenSniffpass = () => setOpenSniffpass((o) => !o);
    const handleSniffpassBadge = () => toggleOpenSniffpass();

    const handleBook = async (type) => {
        setMobilePhotoGallery(false);
        setDesktopPhotoGallery(false);

        if (!userDetails?.id) {
            const addedSrc = type == RESERVATION_TYPE.BOOK ? SPOT_SRC.WEB_SPOT : SPOT_SRC.WEB_CALENDAR;
            const signSrc = type == RESERVATION_TYPE.BOOK ? SIGN_UP_SRC.CHECKOUT_WEB : SIGN_UP_SRC.CALENDAR_WEB;
            let redirectUrl = `${window.location.href}#${addedSrc}`;

            const bookFrom = type == RESERVATION_TYPE.BOOK ? SPOT_SRC.WEB_SPOT : SPOT_SRC.WEB_CALENDAR;
            CookieService.default.set(COOKIE_PARAM_NAME.FRONT_INTERSTITIAL_BEFORE_CALENDAR_FROM, `${window.location.pathname}#${bookFrom}`, {
                expires: 0,
            });
            redirectUrl =
                window.location.origin + RouteFormatter.subscriptionsNew(null, { query: { src: SPOT_SRC_MEMBERSHIP.WEB_CALENDAR, id: spot.id } });

            CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, redirectUrl, { expires: 1 });
            CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, signSrc, { expires: 1 });
            setIsBlurTest(true);
            setShowCalendar(addedSrc);
            return;
        }

        const isLowRating = spot.rating !== null ? spot.rating < LOW_RATING_THRESHOLD : false;
        const isLongInactive = spot.inactiveWarning;
        const isFencingIssue =
            spot.enclosureType === ENCLOSURE_TYPE.FULLY_FENCED && spot.fencingPercentage !== null && spot.fencingPercentage < LOW_FENCING_THRESHOLD;
        const isCleanIssue = spot.cleanlinessPercentage && spot.cleanlinessPercentage < LOW_CLEAN_THRESHOLD;
        const isPhotosIssue = spot.spotPhotos?.length < LOW_PHOTOS_THRESHOLD;

        if (isLowRating || isLongInactive || isFencingIssue || isCleanIssue || isPhotosIssue) {
            if (!userDetails.id || (userDetails.id && !spot?.hasBookedBefore)) {
                setWarning({
                    isOpen: true,
                    isLowRating,
                    isLongInactive,
                    isFencingIssue,
                    isCleanIssue,
                    isPhotosIssue,
                    type,
                    SSR: true,
                });
                return;
            }
        }

        switch (type) {
            case RESERVATION_TYPE.BOOK:
                window.location.hash = SPOT_SRC.WEB_SPOT;
                setShowCalendar(SPOT_SRC.WEB_SPOT);
                break;
            case RESERVATION_TYPE.CALENDAR:
                window.location.hash = SPOT_SRC.WEB_CALENDAR;
                setShowCalendar(SPOT_SRC.WEB_CALENDAR);
                break;
            default:
                break;
        }
    };

    const goToReviews = () => reviewsRef.current && scrollToElement(reviewsRef.current, isMobile);
    const goToHost = () => hostRef.current && scrollToElement(hostRef.current, isMobile);
    const goToNewSniffpass = () => setIsBlurTest(true);

    const moreHandler = async () => {
        const re = `${window.location.pathname}#${AUTH_TESTS.MORE_REVIEWS}`;
        CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, publicPark ? SIGN_UP_SRC.CITY_DOG_PARK_WEB : SIGN_UP_SRC.SPOT_DETAILS_WEB, {
            expires: 1,
        });
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
        setIsBlurTest(true);
    };

    const handleCloseCal = () => {
        window.location.hash = '';
        setShowCalendar('');
    };

    if (mobilePhotoGallery) {
        return (
            <RenderMobilePhotoGallery
                {...{
                    spot,
                    singleViewPhoto,
                    singlePhotoHandler,
                    setMobilePhotoCount,
                    setMobilePhotoGallery,
                    setSingleViewPhoto,
                    mobilePhotoCount,
                    handleBook,
                    handleSwipeMobile,
                    publicPark,
                }}
            />
        );
    }

    if (publicPark) {
        return (
            <PublicPark
                SSR
                {...{
                    spot,
                    useRef,
                    rating,
                    sortBy,
                    goToHost,
                    favSpots,
                    isMobile,
                    useState,
                    useEffect,
                    serverSSR,
                    setRating,
                    listBread,
                    handleBook,
                    shareModal,
                    publicPark,
                    reviewsRef,
                    changeSort,
                    isBlurTest,
                    userDetails,
                    usePrevious,
                    moreHandler,
                    sortReviews,
                    useCallback,
                    useAddReply,
                    useOnScreen,
                    dataReviews,
                    goToReviews,
                    getProbTest,
                    setIsBlurTest,
                    singleViewPhoto,
                    useHandleUpvote,
                    useGetShareLink,
                    toggleShareModal,
                    mobilePhotoCount,
                    useGetSpotReviews,
                    handleSwipeMobile,
                    handleChangeStars,
                    desktopPhotoCount,
                    useMutateFavorites,
                    setSingleViewPhoto,
                    getTestWithProbSSR,
                    singlePhotoHandler,
                    setMobilePhotoCount,
                    desktopPhotoGallery,
                    setDesktopPhotoCount,
                    handleSniffpassBadge,
                    setMobilePhotoGallery,
                    handleNextDesktopGallery,
                    handleBackDesktopGallery,
                    toggleDesktopPhotoGallery,
                }}
            />
        );
    }

    return (
        <>
            <SeoLocalBusiness spot={spot} withReviews={spot.reviews} />
            <div className="spot-view-page container">
                <div className="spot-detail-block">
                    <div className="head-container">
                        <div className="d-md-none">
                            <RenderHeadMobile
                                {...{
                                    spot,
                                    setMobilePhotoGallery,
                                    handleSwipeMobile,
                                    mobilePhotoCount,
                                    listBread,
                                    goToReviews,
                                    goToHost,
                                    handleBook,
                                    handleSniffpassBadge,
                                    getTestWithProbSSR,
                                    getProbTest,
                                    isMobile,
                                    useState,
                                    useEffect,
                                    serverSSR,
                                    useStateSSR,
                                    setIsBlurTest,
                                    spotPhotos,
                                    isRecentReviewsTest,
                                }}
                            />
                        </div>
                        <div className="d-none d-md-block">
                            <RenderHeadDesktop
                                SSR
                                {...{
                                    listBread,
                                    spot,
                                    goToHost,
                                    goToReviews,
                                    toggleDesktopPhotoGallery,
                                    desktopPhotoCount,
                                    desktopPhotoGallery,
                                    handleNextDesktopGallery,
                                    handleBackDesktopGallery,
                                    handleSniffpassBadge,
                                    isMobile,
                                    useState,
                                    useEffect,
                                    useCallback,
                                    favSpots,
                                    useMutateFavorites,
                                    userDetails,
                                    useGetShareLink,
                                    setDesktopPhotoCount,
                                    serverSSR,
                                    spotPhotos,
                                    isSpotLastActTest,
                                    lastActiveAt,
                                    spotPublishedAt,
                                    isRecentReviewsTest,
                                }}
                            />
                        </div>
                    </div>
                    <ListingFencing
                        isMobileSSR={isMobile}
                        useStateSSR={useState}
                        encls={spot.enclosureType}
                        fncHeight={spot.fenceHeight}
                        gaps={spot.gaps}
                        fencingType={spot.fencingType}
                        fencingDetail={spot.fencingDetail}
                        fencingPercentage={spot.fencingPercentage}
                        smallDogFencingPercentage={spot.smallDogFencingPercentage}
                        isSmallDogFenceTest={isSmallDogFenceTest}
                    />
                    <ListingPresent
                        spotId={spot.id}
                        isMobile={isMobile}
                        userDetails={userDetails}
                        anmlsPrsnt={spot.domesticAnimalsPresent}
                        dogsPrsnt={spot.dogsPresent}
                        pplePrsnt={spot.peoplePresent}
                        dogsAway={spot.dogsAway}
                        peopleAway={spot.peopleAway}
                        prvtEntry={spot.privateEntry}
                        describePrivateEntry={spot.describePrivateEntry}
                        describeDomesticAnimalsPresent={spot.describeDomesticAnimalsPresent}
                        describeDogsPresent={spot.describeDogsPresent}
                        describePeoplePresent={spot.describePeoplePresent}
                        dogsPercentage={spot.dogsPercentage}
                        otherAnimalsPercentage={spot.otherAnimalsPercentage}
                        peoplePercentage={spot.peoplePercentage}
                        useStateSSR={useState}
                        serverSSR={serverSSR}
                        setIsBlurTest={setIsBlurTest}
                        isBlurTest={isBlurTest}
                    />
                    <ListingAmenities
                        userDetails={userDetails}
                        isMobileSSR={isMobile}
                        useEffectSSR={useEffect}
                        useStateSSR={useState}
                        dogsAmenities={spot.dogsAmenities}
                        essentialAmenities={spot.essentialAmenities}
                        peopleAmenities={spot.peopleAmenities}
                        venueAmenities={spot.venueAmenities}
                        serverSSR={serverSSR}
                        setIsBlurTest={setIsBlurTest}
                        isBlurTest={isBlurTest}
                    />
                    <RenderPrice {...{ isMobile, spot, setIsBlurTest }} SSR />
                    <ListingLocation
                        isMobileSSR={isMobile}
                        useStateSSR={useState}
                        latitude={spot.latitude}
                        longitude={spot.longitude}
                        dscrpt={spot.description}
                        hazards={spot.hazards}
                        clean={spot.cleanlinessPercentage}
                        city={spot.city}
                        state={spot.state}
                        distanceFrom={spot.distanceFrom}
                        venueAmenities={spot.venueAmenities}
                        isSpotFaqsTest={isSpotFaqsTest}
                        isFaqOpen={isFaqOpen}
                        toggleFaq={toggleFaq}
                    />
                    <ListingExtras
                        spot={spot}
                        extras={spot.extras ? [...spot.extras].sort(sortByObjTitle) : []}
                        isMobileSSR={isMobile}
                        useEffectSSR={useEffect}
                        useStateSSR={useState}
                        userDetails={userDetails}
                        serverSSR={serverSSR}
                        setIsBlurTest={setIsBlurTest}
                        isBlurTest={isBlurTest}
                    />
                    <ListingRules
                        useEffectSSR={useEffect}
                        useStateSSR={useState}
                        isMobileSSR={isMobile}
                        breedSizeRestrictions={spot.breedSizeRestrictions}
                        hostPresencePreference={spot.hostPresencePreference}
                        reservationDelayTime={spot.reservationDelayTime}
                        maximumDogsAllowed={spot.maximumDogsAllowed}
                        minimumLength={spot.minimumLength}
                        instantBook={spot.instantBook}
                        rules={spot.rules}
                        avatar={spot.host?.avatarAws}
                    />

                    {/* RENDER CALENDAR */}
                    {showCalendar ? (
                        isMobile ? (
                            <>
                                <ListingAvailability {...{ isMobile, handleBook }} />
                                <MobileSubPage
                                    show={isMobile && !!showCalendar}
                                    className="calendar"
                                    title="Spot availability"
                                    onBack={handleCloseCal}
                                    useEffectSSR={useEffect}
                                    useStateSSR={useState}
                                >
                                    <GuestSpotCalendar
                                        {...{
                                            spotDetails: spot,
                                            isMobile,
                                            spotId: spot.id,
                                            showCalendar,
                                            useEffect,
                                            useState,
                                            usePrevious,
                                            useGetAvailableTimes,
                                            useLazyGetIntentCal,
                                            useUpdateIntent,
                                            userDetails,
                                            Select,
                                            trackEvent,
                                        }}
                                    />
                                </MobileSubPage>
                            </>
                        ) : (
                            <ModalMobile isOpen={!!showCalendar} toggle={handleCloseCal} title="Spot availability" className="spot-avail-desktop">
                                <GuestSpotCalendar
                                    {...{
                                        spotDetails: spot,
                                        isMobile,
                                        spotId: spot.id,
                                        showCalendar,
                                        useEffect,
                                        useState,
                                        usePrevious,
                                        useGetAvailableTimes,
                                        useLazyGetIntentCal,
                                        useUpdateIntent,
                                        userDetails,
                                        Select,
                                        trackEvent,
                                    }}
                                />
                            </ModalMobile>
                        )
                    ) : (
                        ''
                    )}
                    {/*  */}

                    {/* RENDER WARNING BEFORE BOOK */}
                    <RenderModalWarning
                        {...{
                            warning,
                            setWarning,
                            spotRating: spot.rating?.toPrecision(2),
                            onAskQuestion,
                            setShowCalendar,
                            useState,
                        }}
                    />
                    {/*  */}

                    <div ref={reviewsRef}>
                        <ListingReviews
                            isMobile={isMobile}
                            spot={spot}
                            host={spot.host}
                            isTop={spot.top}
                            spotId={spot.id}
                            rating={spot.rating}
                            reviews={spot.reviews}
                            changeSort={changeSort}
                            moreHandler={moreHandler}
                            sortReviews={sortReviews}
                            reviewsCount={spot.reviewsCount}
                            useEffectSSR={useEffectSSR}
                            useStateSSR={useStateSSR}
                            useRefSSR={useRefSSR}
                            useAddReplySSR={useAddReply}
                            useDeleteReplySSR={useDeleteReply}
                            useHandleUpvoteSSR={useHandleUpvote}
                            useGetSpotReviewsSSR={useGetSpotReviews}
                            useOnScreenSSR={useOnScreen}
                            userDetails={userDetails}
                            dataReviews={dataReviews}
                            sortBy={sortBy}
                            serverSSR={serverSSR}
                            setIsBlurTest={setIsBlurTest}
                            isBlurTest={isBlurTest}
                            isEnhancedReviewTest={isEnhancedReviewTest}
                        />
                    </div>
                    <div ref={hostRef}>
                        <ListingHost
                            hostId={spot.host?.id}
                            nameAndInitial={spot.host?.nameAndInitial}
                            avatar={spot.host?.avatarAws}
                            info={spot.host?.aboutHost}
                            email={spot.host?.email}
                            joinDate={spot.host?.createdAt}
                            acceptanceRate={spot.acceptanceRate}
                            responseTime={spot.responseTime}
                            instantBook={spot.instantBook}
                            isMobile={isMobile}
                            useStateSSR={useState}
                            serverSSR={serverSSR}
                            setIsBlurTest={setIsBlurTest}
                            isSpotLastActTest={isSpotLastActTest}
                            spotPublishedAt={spotPublishedAt}
                            lastActiveAt={lastActiveAt}
                        />
                    </div>
                    <div className="ask-container mx-2 mx-md-0">
                        <div className="row ask-row">
                            <div className="col-md-12">
                                <SniffButton className="mb-3" color="secondary" size="lg" onClick={onAskQuestion}>
                                    Ask the host a question
                                </SniffButton>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none">
                        <RenderNearbySpots SSR {...{ spot, nearbySpotSPhotos, useEffect, useState, usePrevious }} />
                    </div>
                    {!showCalendar && (
                        <ReservationPanel
                            commentsNmb={spot.reviewsCount}
                            title={spot.title}
                            rating={spot.rating}
                            price={spot.price}
                            instantBook={spot.instantBook}
                            live={spot.live && spot.host?.id > 0}
                            handleBook={handleBook}
                        />
                    )}
                </div>
                <div className={`desktop-book-block${!spot.live || spot.host?.id == 0 ? ' disabled' : ''}`}>
                    <div className="desktop-book-block__content">
                        <DesktopBookBlock {...{ spot, handleBook, useState, isRecentReviewsTest }} />
                    </div>
                    <RenderSpotBadge {...{ spot }} />
                    {spot.isMember && <RenderUserIsMember SSR />}
                </div>
            </div>
            <div className="d-none d-md-block">
                <RenderNearbySpots SSR {...{ spot, nearbySpotSPhotos, useEffect, useState, usePrevious }} />
            </div>
            <div className="d-md-none spot-view-margin" />
            <ModalMobile isOpen={openSniffpass} toggle={toggleOpenSniffpass}>
                <div className={bs('header')}>
                    <div className={bs('close')} onClick={toggleOpenSniffpass}>
                        <SvgCross2 />
                    </div>
                </div>
                <div className={bs('content')}>
                    <div className={bs('thumbnail')}>
                        <SvgSubscription />
                    </div>
                    <p className="snif-p snif-semibold mt-2">Become a Sniffpass holder!</p>
                    <p className="snif-s1 mt-1 pt-05 px-md-3">
                        Get discounts on all bookings at all spots by buying monthly or annual credits! This spot offers additional discounts.
                    </p>

                    <p className="snif-s1 mt-3">Starting at</p>
                    <p className="snif-l2 snif-semibold">{showPrice(16)}</p>
                    <p className="snif-s2 snif-medium mt-05">per month</p>
                    <SniffButton className={bs('cta')} size="lg" block onClick={goToNewSniffpass}>
                        Learn more
                    </SniffButton>
                </div>
            </ModalMobile>
            <BlurSignupModal
                {...{
                    isBlurTest,
                    setIsBlurTest,
                    isMobile,
                    useStateSSR: useState,
                }}
                spotDetail
            />
        </>
    );
};

export default SpotViewPage;
